// Project the same provenance contract used by the final graph into viewer tables.
export function statisticalPreviewTables(result) {
  const titles = new Map(result.entities.map(entity => [entity.entity_id, entity.graph_title.toUpperCase()]));
  const entities = result.entities.map((entity, index) => ({
    ...entity, id: entity.entity_id, title: titles.get(entity.entity_id), display_name: entity.name,
    type: entity.display_category, human_readable_id: index, text_unit_ids: [],
    aliases: JSON.stringify(entity.aliases || []),
  }));
  const groups = new Map();
  for (const edge of result.relationships) {
    const source = titles.get(edge.source), target = titles.get(edge.target);
    if (!source || !target) continue;
    const key = JSON.stringify([source, target].sort());
    if (!groups.has(key)) groups.set(key, { source, target, rows: [] });
    groups.get(key).rows.push(edge);
  }
  const relationships = Array.from(groups.values(), ({ source, target, rows }, index) => ({
    id: `stats-preview-${index}`, human_readable_id: index, source, target,
    weight: rows.length, description: rows.map(row => JSON.stringify(row)).join('\n'), text_unit_ids: [],
  }));
  return { entities, relationships, documents: [], text_units: [], communities: [], community_reports: [] };
}
